import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as GoogleLogo } from 'assets/logos/google.svg'
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import useLayout from "hooks/useLayout"
import useAuth from "hooks/useAuth"
import { decodeFirebaseError } from "utils/firebaseHelpers"

const LoginGoogleForm: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {

    const { t } = useTranslation()
    const { addToast } = useLayout();
    const { googleSignIn, isGoogleSigningIn } = useAuth();

    const handleClick = async () => {
        if (disabled) {
            addToast({ text: t('errorAcceptTerms'), colorScheme: 'red' })
            return
        }
        try {
            await googleSignIn();
            addToast({ text: t('toastGoogleLoginSuccess'), colorScheme: 'green' })
        } catch (error: any) {
            const errorMessage = decodeFirebaseError(error?.code || error?.message || 'Unknown error')
            addToast({ text: errorMessage, colorScheme: 'red' })
        }
    };

    return (
        <ButtonGroup className="input-holder">
            <Button wideOnMobile 
                type="button" 
                design="white" 
                onClick={handleClick}
                disabled={isGoogleSigningIn || disabled}
            >
                <GoogleLogo />
                <span>{isGoogleSigningIn ? t('buttonWaiting') : t('buttonSignInWithGoogle')}</span>
            </Button>
        </ButtonGroup>
    );
};

export default LoginGoogleForm;